<div class="mysuserinfoscrolldiv">
  <form id="myUserInfoForm" #myuserinfoform="ngForm" class="pb-5 form-row">
    <div class="col-12 col-lg-6">
      @if (user.firstName) {
        <div class="form-row">
          <div class="form-group col-sm-12 col-lg-10">
            <label for="firstname" class="col-form-label">First Name:</label>
            <input type="text" id="firstname" class="form-control" [value]="user.firstName" readonly />
          </div>
        </div>
      }
      @if (user.lastName) {
        <div class="form-row">
          <div class="form-group col-sm-12 col-lg-10">
            <label for="lastname" class="col-form-label">Last Name:</label>
            <input type="text" id="lastname" class="form-control" [value]="user.lastName" readonly />
          </div>
        </div>
      }
      @if (user.emailAddress) {
        <div class="form-row">
          <div class="form-group col-sm-12 col-lg-10">
            <label for="email" class="col-form-label">Email Address:</label>
            <input id="email" type="text" class="form-control" [value]="user.emailAddress" readonly />
          </div>
        </div>
      }
      @if (user.role) {
        <div class="form-row">
          <div class="form-group col-sm-12 col-lg-10">
            <label for="rolename" class="col-form-label">Role:</label>
            <input id="rolename" type="text" class="form-control" [value]="user.role.roleName" readonly />
          </div>
        </div>
      }
      @if (user.userOrgs) {
        <div class="form-row">
          <div class="form-group col-sm-12 col-lg-10">
            <label for="markets" class="col-form-label">Markets:</label>
            <select id="markets" class="form-control" multiple readonly size="5">
              @for (market of marketList; track market) {
                <option [value]="market.orgId">{{market.orgName}}</option>
              }
            </select>
          </div>
        </div>
      }

      @if (user.approvalHierarchies && user.approvalHierarchies.length > 0) {
        <div class="form-row">
          <div class="form-group col-sm-12 col-lg-10">
            <label class="col-form-label">Managers:</label>
            <p-table [value]="user.approvalHierarchies" [scrollable]="true" scrollHeight="flex" styleClass="p-datatable-gridlines">
              <ng-template #header let-columns>
                <tr>
                  <th style="flex: 1;">
                    <div class="text-ellipsis" title="Market">
                      Market
                    </div>
                  </th>
                  <th  style="flex: 1;">
                    <div class="text-ellipsis" title="Manager">
                      Manager
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template #body let-rowData>
                <tr>
                  <td style="flex: 1;">
                    <div class="text-ellipsis" title="{{rowData.marketName}}">
                      {{rowData.marketName}}
                    </div>
                  </td>
                  <td style="flex: 1;">
                    <div class="text-ellipsis" title="{{rowData.manager.displayName}}">
                      {{rowData.manager.displayName}}
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      }
      @if (user.approvalLimits?.length > 0) {
        <div class="form-row">
          <div class="form-group col-sm-12 col-lg-10">
            <label class="col-form-label">Approval Limits:</label>
            <p-table [value]="user.approvalLimits" [scrollable]="true" scrollHeight="flex" styleClass="p-datatable-gridlines">
              <ng-template #header let-columns>
                <tr>
                  <th style="flex: 1;">Market </th>
                  <th  style="flex: 1;">Approval Limit </th>
                </tr>
              </ng-template>
              <ng-template #body let-rowData>
                <tr>
                  <td style="flex: 1;">
                    <div class="text-ellipsis" title="{{rowData.marketName}}">
                      {{rowData.marketName}}
                    </div>
                  </td>
                  <td style="flex: 1;">
                    <div class="text-ellipsis" title=" {{rowData.value | currency}}">
                      {{rowData.value | currency}}
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      }
    </div>

    <div class="col-12 col-lg-6">
      <!--MY SCHEDULES-->
      @if (displayMySchedules) {
        <div class="form-row">
          <label class="col-form-label">My Schedules:</label>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-12 col-lg-10 my-schedules-text">
            Default communities are based on your Lot/Block assignments (maximum is 10 Communities).
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-12 col-lg-10 text-right">
            Select from full Market list <p-checkbox [(ngModel)]="displayMarketCommunities"
            name="displaymarketcommunities" binary="true" (onChange)="switchCommunityList($event)" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-sm-12 col-lg-10 ui-fluid w-100">
          <p-select name="subgroupfilter" [options]="subGroupList"
            (onChange)="onSubGroupFilter($event.value)" [(ngModel)]="selectedSubGroupFilter"
            optionLabel="subGroupName" placeholder="Select Subgroup" [style]="{'width':'100%'}"
          [showClear]="true" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-sm-12 col-lg-10 ui-fluid w-100">
          <p-listbox id="user-community-select" [options]="communityOptions" optionLabel="communityLabel"
            [(ngModel)]="selectedCommunities" name="usercommunities" multiple="multiple" checkbox="checkbox"
            [listStyle]="{'max-height':'250px'}" [showToggleAll]="false" dataKey="orgId"
            (onChange)="onCommunitySelectionChange()">
            <p-header>
              Community
            </p-header>
            <p-footer>
              ({{selectedCommunities.length}}) communities selected.
            </p-footer>
          </p-listbox>
        </div>
      </div>
      <div class="form-row text-right">
        <div class="form-group col-sm-12 col-lg-10">
          <p-button styleClass="clear-filters-button" (onClick)="revertCommunitySelectionAssignment()"
          class="ui-button-primary" label="Reset per Lot/Blk assignment" />
        </div>
      </div>
    }
  </div>
</form>
</div>